import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchTofuWorkspacesSuggestionsArgs, SearchSuggestionsOutput } from "types/generated";

export const SEARCH_TOFU_WORKSPACES_SUGGESTIONS: TypedDocumentNode<
  {
    searchTofuWorkspacesSuggestions: SearchSuggestionsOutput;
  } & QuerySearchTofuWorkspacesSuggestionsArgs
> = gql`
  query SearchTofuWorkspacesSuggestions($input: SearchSuggestionsInput!) {
    searchTofuWorkspacesSuggestions(input: $input) {
      filteredCount
    }
  }
`;
